import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';
import { Toast } from "@kaleyra/emmy";

export const BOT_DETAILS_LOADING = "BOT_DETAILS_LOADING";
export const BOT_DETAILS_SUCCESS = "BOT_DETAILS_SUCCESS";
export const BOT_DETAILS_FAILED = "BOT_DETAILS_FAILED";

export const BOT_LANGUAGES_LOADING = "BOT_LANGUAGES_LOADING";
export const BOT_LANGUAGES_SUCCESS = "BOT_LANGUAGES_SUCCESS";
export const BOT_LANGUAGES_FAILED = "BOT_LANGUAGES_FAILED";

export const BOT_TYPES_LOADING = "BOT_TYPES_LOADING";
export const BOT_TYPES_SUCCESS = "BOT_TYPES_SUCCESS";
export const BOT_TYPES_FAILED = "BOT_TYPES_FAILED";

export const BOT_DOC_LOADING = "BOT_DOC_LOADING";
export const BOT_DOC_SUCCESS = "BOT_DOC_SUCCESS";
export const BOT_DOC_FAILED = "BOT_DOC_FAILED";

export const DOC_UPLOAD_INIT = "DOC_UPLOAD_INIT";
export const DOC_UPLOAD_SUCCESS = "DOC_UPLOAD_SUCCESS";
export const DOC_UPLOAD_FAILED = "DOC_UPLOAD_FAILED";


export const getBotdetails = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: BOT_DETAILS_LOADING });

        let failedType: string = BOT_DETAILS_FAILED;

        let url: string = `/chat-bot`;

        networkCall("get", url, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: BOT_DETAILS_SUCCESS, payload: { respose: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const getBotLanguages = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: BOT_LANGUAGES_LOADING });

        let failedType: string = BOT_LANGUAGES_FAILED;

        let url: string = `/chat-bot/languages`;

        networkCall("get", url, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: BOT_LANGUAGES_SUCCESS, payload: { respose: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const getBotTypes = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: BOT_TYPES_LOADING });

        let failedType: string = BOT_TYPES_FAILED;

        let url: string = `/chat-bot/type`;

        networkCall("get", url, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: BOT_TYPES_SUCCESS, payload: { respose: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const docUpload = (data: any, cb: (data: any, uuid?: string) => void, uuid: string = '') => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: DOC_UPLOAD_INIT });

        let url: string = `/document/upload`;

        networkCall("post", url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(res, uuid);
                    dispatch({ type: DOC_UPLOAD_SUCCESS, payload: { respose: res } });
                } else {
                    Toast(res.message, "error");
                    dispatch({ type: DOC_UPLOAD_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: DOC_UPLOAD_FAILED, payload: { error: error.response.data } });
                }
            });
    }

}

export const saveRequest = (data: any, cb: (message: string, status: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {

        // let failedType: string = BOT_DOC_FAILED;

        let url: string = `/chat-bot`;

        networkCall("post", url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(res.message, true);
                    // dispatch({ type: BOT_DOC_SUCCESS, payload: {respose: res}});
                } else {
                    cb(res.message, false);
                    // dispatch({ type: failedType, payload: {error: res}});
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(error.response.data.message, false);
                    // dispatch({ type: failedType, payload: {error: error.response.data}});
                }
            });
    }

}
